"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var USER_TYPES;
(function (USER_TYPES) {
    USER_TYPES["bot"] = "bot";
    USER_TYPES["recipient"] = "recipient";
})(USER_TYPES || (USER_TYPES = {}));
var Message = /** @class */ (function () {
    function Message(message, userType, timestamp, options) {
        this.message = message;
        this.userType = userType;
        this.timestamp = moment_1.default(timestamp);
        this.options = options;
    }
    Object.defineProperty(Message.prototype, "getMessage", {
        get: function () {
            return this.message;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "getUserType", {
        get: function () {
            return this.userType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "getTimestamp", {
        get: function () {
            return this.timestamp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "getOptions", {
        get: function () {
            return this.options;
        },
        enumerable: true,
        configurable: true
    });
    return Message;
}());
exports.Message = Message;
